import React from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { TEST_IDS } from "@/constants/testIds";
import LanguageSwitcher from "@/components/layout/LanguageSwitcher";

export default function PublicNav() {
    const { t } = useI18n();
    const { scrollY } = useScroll();
    const bg = useTransform(scrollY, [0, 80], ["rgba(15,15,26,0)", "rgba(15,15,26,0.75)"]);
    const border = useTransform(scrollY, [0, 80], ["rgba(255,255,255,0)", "rgba(255,255,255,0.08)"]);

    return (
        <motion.header
            style={{ backgroundColor: bg, borderBottomColor: border }}
            className="fixed top-0 left-0 right-0 z-50 border-b backdrop-blur-xl"
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-10 h-16 flex items-center justify-between">
                <Link to="/" data-testid={TEST_IDS.publicNav.logo} className="flex items-center gap-2 group">
                    <span className="relative flex items-center justify-center w-8 h-8 rounded-lg btn-cta">
                        <span className="text-white font-black text-sm">B</span>
                    </span>
                    <span className="font-display font-black text-lg tracking-tight text-white">BOXEB2B</span>
                </Link>

                <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-400">
                    <a href="#features" data-testid={TEST_IDS.publicNav.features} className="hover:text-white transition">{t.nav.features}</a>
                    <a href="#pricing" data-testid={TEST_IDS.publicNav.pricing} className="hover:text-white transition">{t.nav.pricing}</a>
                    <Link to="/blog" data-testid="public-nav-blog" className="hover:text-white transition">Blog</Link>
                    <a href="#faq" data-testid={TEST_IDS.publicNav.faq} className="hover:text-white transition">{t.nav.faq}</a>
                </nav>

                <div className="flex items-center gap-3">
                    <LanguageSwitcher testId={TEST_IDS.publicNav.langToggle} />
                    <Link
                        to="/login"
                        data-testid={TEST_IDS.publicNav.login}
                        className="hidden sm:inline text-sm text-zinc-300 hover:text-white transition px-3 py-2"
                    >
                        {t.nav.login}
                    </Link>
                    <Link
                        to="/register"
                        data-testid={TEST_IDS.publicNav.register}
                        className="btn-cta text-white font-semibold text-sm px-4 py-2 rounded-full"
                    >
                        {t.nav.register}
                    </Link>
                </div>
            </div>
        </motion.header>
    );
}
